var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.mark)?_c('div'):(_vm.mark.value === 0)?_c('div',[_vm._v(_vm._s(_vm.$t('student.abs')))]):(_vm.mark.value === 1)?_c('div',[_c('v-icon',{staticClass:"non-evaluable-mark",attrs:{"color":"green"}},[_vm._v("check_circle_outline")])],1):_c('div',[_vm._v(_vm._s(_vm.mark.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }